module.exports = __webpack_public_path__ + "static/media/kumquat.6888f9f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/kumquat.jpeg
// module id = 2034
// module chunks = 0